import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

defineBlock({
    type: 'for_var',
    colour: CATEGORIES.control.color,
    tooltip: '変数を使って指定した回数だけ繰り返します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('FOR', { fontSize: 12, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'field',
                    name: 'VAR_LABEL',
                    instance: () =>
                        new FieldVariableLabel('i', {
                            fontWeight: 'normal',
                            varType: 'float',
                            colorOverride: CATEGORIES.variable.color,
                            isPrivate: true,
                        }),
                },
                { type: 'label', text: 'を' },
            ],
        },
        {
            kind: 'value',
            name: 'FROM',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 0 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'から' }],
        },
        {
            kind: 'value',
            name: 'TO',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 5 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'まで' }],
        },
        {
            kind: 'value',
            name: 'STEP',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 1 } },
        },
        {
            kind: 'dummy',
            fields: [
                { type: 'label', text: 'ずつ' },
                {
                    type: 'field',
                    name: 'DIRECTION',
                    instance: () =>
                        new FieldOperatorDropdown(
                            [
                                { value: 'increment', label: '増やして' },
                                { value: 'decrement', label: '減らして' },
                            ],
                            'increment',
                            undefined,
                            CATEGORIES.control.color,
                        ),
                },
                { type: 'label', text: 'くりかえす ' },
            ],
        },
        {
            kind: 'statement',
            name: 'DO',
        },
    ],
    onInit(this: Blockly.Block) {
        this.workspace.addChangeListener((e: Blockly.Events.Abstract) => {
            if (e.type !== Blockly.Events.BLOCK_CHANGE) return;
            const ce = e as Blockly.Events.BlockChange;
            if (ce.element !== 'field' || ce.name !== 'VAR_LABEL') return;
            if (ce.blockId !== this.id) return;
            const inner = this.getDescendants(false);
            for (const b of inner) {
                if (b.id === this.id) continue;
                const field = b.getField('VAR_LABEL') as FieldVariableLabel | null;
                if (field) {
                    requestAnimationFrame(() => {
                        Blockly.Events.fire(
                            new Blockly.Events.BlockChange(b, 'field', 'VAR_LABEL', '', field.getValue() ?? ''),
                        );
                    });
                }
            }
        });
    },
});
